import api from "../http/api";

export const FEATURE_FLAG_KEYS = Object.freeze({
  AI_INSIGHTS_TAB: "AiInsightsTab",
});

/**
 * Resolve o estado de uma feature flag para o usuário autenticado.
 * Retorna { key, isEnabled, blocked } onde:
 *  - isEnabled: estado bruto da flag no banco
 *  - blocked: true quando o usuário deve ser impedido de acessar a feature
 *
 * Em caso de falha (rede, 5xx, chave desconhecida etc.) retorna o estado
 * "fail-open" { isEnabled: false, blocked: false } para não derrubar a UI.
 * Isso é seguro porque a API protege a feature de qualquer forma.
 */
export const getFeatureFlagState = async (key) => {
  if (!key) {
    return { key: null, isEnabled: false, blocked: false };
  }

  try {
    const response = await api.client.get(
      `api/v1/FeatureFlags/${encodeURIComponent(key)}/me`
    );
    return {
      key: response.data?.key ?? key,
      isEnabled: !!response.data?.isEnabled,
      blocked: !!response.data?.blocked,
    };
  } catch (error) {
    console.warn(
      `Falha ao consultar feature flag '${key}':`,
      error?.message
    );
    return { key, isEnabled: false, blocked: false };
  }
};
